import React, { useContext } from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { setMultiSelectOperationLinkAnalytics } from '../../utils/add-manage-user-analytics';
export var UsersMultiselectActionButtons = function (_a) {
    var isEnabled = _a.isEnabled, isMultiInviteDisabled = _a.isMultiInviteDisabled, handleClose = _a.handleClose, handleMultiRemove = _a.handleMultiRemove, handleMultiResendInvites = _a.handleMultiResendInvites;
    var channel = useContext(ExperienceContext).channel;
    var isMobile = channel === 'mobile';
    return (React.createElement("div", { className: "sui-flex sui-grow sui-justify-between sm:sui-gap-6 sui-align-baseline" },
        React.createElement(Button, { disabled: !isEnabled, className: "md:sui-ml-0 sui-ml-auto", onClick: function () {
                setMultiSelectOperationLinkAnalytics('remove');
                handleMultiRemove();
            } },
            React.createElement(Typography, { className: "sui-font-regular sui-text-base", decoration: "underline", color: isEnabled ? 'primary' : 'inactive' }, "Remove")),
        React.createElement(Button, { disabled: isMultiInviteDisabled, className: "md:sui-ml-0 sui-ml-auto", "data-testid": "multi-resend-invite-btn", onClick: function () {
                setMultiSelectOperationLinkAnalytics('resend invite');
                handleMultiResendInvites();
            } },
            React.createElement(Typography, { className: "sui-font-regular sui-text-base", decoration: "underline", color: !isMultiInviteDisabled ? 'primary' : 'inactive' }, isMobile ? 'Re-invite' : 'Resend Invite')),
        React.createElement(Button, { className: "md:sui-ml-0 sui-ml-auto", onClick: function () {
                setMultiSelectOperationLinkAnalytics('cancel');
                handleClose();
            } },
            React.createElement(Typography, { className: "sui-font-regular sui-text-base", decoration: "underline" }, "Cancel"))));
};
